<template>
    <div v-bind:class="[resultClass]">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'VCol',
  props: ['cssClass', 'size', 'part'],
  data () {
    return {
      resultClass: ''
    }
  },
  created () {
    let result = null
    let sizes = ['xs', 'sm', 'md', 'lg', 'xlg']
    if (sizes.indexOf(this.size) > -1 && parseInt(this.part) > 0 && parseInt(this.part) < 13) {
      result = 'col-' + this.size + '-' + this.part
    } else {
      result = this.cssClass
    }
    this.resultClass = result || 'col-md-6'
  },
  computed: {
  }
}
</script>

<style scoped>

</style>
